import { render, staticRenderFns } from "./Liver.vue?vue&type=template&id=fd5b8128&scoped=true&"
import script from "./Liver.vue?vue&type=script&lang=js&"
export * from "./Liver.vue?vue&type=script&lang=js&"
import style0 from "./Liver.vue?vue&type=style&index=0&id=fd5b8128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5b8128",
  null
  
)

export default component.exports